import UsersPage from "@/app/users/pages/UsersPage.vue";

export default [
  {
    path: "/users",
    name: "users",
    component: UsersPage,
    // children: [
    //   {
    //     path: "board",
    //     component: () =>
    //       import("@/app/users/components/templates/UsersTemplate"),
    //     meta: {
    //       requiresAuth: true,
    //     },
    //   },
    //   {
    //     path: "profiles",
    //     component: () =>
    //       import(
    //         "@/app/users/components/templates/ProfilesTemplate"
    //       ),
    //     meta: {
    //       requiresAuth: true,
    //     },
    //   },
    // ],
    meta: {
      requiresAuth: true,
    },
  },
];
